import { Params } from './getParams';

export type CreateDeviceProps = Pick<
  Params,
  | 'deviceType'
  | 'deviceId'
  | 'macAddress'
  | 'screenManufacturer'
  | 'screenModel'
  | 'screenSerialNumber'
  | 'screenOsVersion'
>;

interface CreateDeviceBodyProps {
  model: string;
  device_type?: string;
  device_id?: string;
  screen_manufacturer?: string;
  screen_model?: string;
  screen_serial_number?: string;
  screen_os_version?: string;
  mac_address?: string;
}

interface CreateDeviceResult {
  deviceId: string;
  accessToken: string;
}

const apiUrl = process.env.API_URL;

// Refactor to use a single object
export async function createLiteDevice(): Promise<CreateDeviceResult> {
  const endpoint = `${apiUrl}/v3/devices/actions/create_lite_device`;
  const res = await fetch(endpoint, { method: 'POST' });

  // TODO: Handle status code 429 (too many attempts), retry later.

  if (!res.ok) {
    throw new Error(
      `Failed to create device, received response status '${res.status}'`,
    );
  }

  let data;

  try {
    data = await res.json();
  } catch (err) {
    throw new Error(`Failed to create device, received invalid response body`);
  }

  if (!data.id) {
    throw new Error(`Failed to create device, missing 'id' in response body`);
  }

  if (!data.api_token) {
    throw new Error(
      `Failed to create device, missing 'api_token' id in response body`,
    );
  }

  return {
    deviceId: data.id,
    accessToken: data.api_token,
  };
}

export default async function createDevice(
  props: CreateDeviceProps,
): Promise<CreateDeviceResult> {
  const endpoint = `${apiUrl}/v3/devices/actions/create_lite_device`;
  const res = await fetch(endpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(getCreateActionBodyProps(props)),
  });

  // TODO: Handle status code 429 (too many attempts), retry later.

  if (!res.ok) {
    throw new Error(
      `Failed to create device, received response status '${res.status}'`,
    );
  }

  let data;

  try {
    data = await res.json();
  } catch (err) {
    throw new Error(`Failed to create device, received invalid response body`);
  }

  if (!data.id) {
    throw new Error(`Failed to create device, missing 'id' in response body`);
  }

  if (!data.api_token) {
    throw new Error(
      `Failed to create device, missing 'api_token' id in response body`,
    );
  }

  return {
    deviceId: data.id,
    accessToken: data.api_token,
  };
}

function getCreateActionBodyProps(
  props: CreateDeviceProps,
): CreateDeviceBodyProps {
  return {
    model: props.deviceType ? props.deviceType : 'SecondScreen',
    device_id: props.deviceId,
    mac_address: props.macAddress,
    device_type: props.deviceType,
    screen_manufacturer: props.screenManufacturer,
    screen_model: props.screenModel,
    screen_serial_number: props.screenSerialNumber,
    screen_os_version: props.screenOsVersion,
  };
}
